import { createContext, useContext } from 'react';

type TLogStreamContext = { state: { logStreamingEnabled: boolean } };

const Context = createContext<TLogStreamContext>({
  state: {
    logStreamingEnabled: false,
  },
});

export default Context;

export const useLogStreamContext = () => useContext(Context);
